import { Divider, List, Typography } from 'antd';
import styled from 'styled-components';

import { Title as TitleComponent } from '@atom/typography/typography';
import { ColorEnum } from '@enum/style/color.enum';

import { StartupListType } from './application-setup-next.options';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Title = styled(TitleComponent).attrs((props) => ({
  level: 2,
  color: props.theme.Title.colorSignUpTitle,
}))`
  padding-top: 24px;
`;

export const Description = styled(Typography.Paragraph)`
  color: ${(props) => props.theme.Title.colorSignUpDescription};
  padding-bottom: 24px;
`;

export const DividerList = styled(Divider)`
  width: 540px;
  min-width: auto;
  margin-bottom: 0;
  margin-top: 0;
`;

export const ListWrapper = styled.div`
  max-width: 540px;
  width: 100%;
`;

export const NextList = styled(List<StartupListType>)`
  width: 100%;

  & .ant-list-item {
    &:last-child {
      border-block-end: 1px solid rgba(5, 5, 5, 0.06);
    }

    &:hover {
      cursor: pointer;
      border-block-end-color: ${ColorEnum.Black80};
    }
  }

  & .ant-list-item-meta-title .ant-typography {
    font-weight: 400;
    line-height: 0;
  }

  & .ant-list-item-meta-description {
    font-size: 14px !important;
  }

  & .ant-list-item-meta-content {
    padding-top: 8px;
    margin: auto 0;
  }

  & .ant-list-item-meta-avatar > svg {
    width: 48px;
    height: 48px;
    fill: ${ColorEnum.Teal100};
  }
`;

export const ItemTitle = styled(TitleComponent)`
  padding-bottom: 4px;
`;
